/**
 * Oftentimes when we add Redo to the cart using the toggle, it happens after some side cart has rendered.
 * Many themes rely on the position of the line item in the cart to be current, and items are added to the top, changing the line number
 * for anything already in there. So we have to do our best to re-render the cart whenever we add/remove redo.
 *
 * This function is called after we add/remove redo from the cart, and contains all of the known methods for reloading the cart in various themes.
 */
export async function renderCart() {
  try {
    if (Shopify?.shop === "augustine-boutique.myshopify.com") {
      await globalThis.theme.cart.updateAllHtml();
    }
    if (Shopify?.shop === "hatch-insane-deal.myshopify.com") {
      /**
       * async function refreshCart(delay = 2000)
       * Refreshes the cart content and state. Pass input delay in milliseconds. Default is 2000.
       */
      await globalThis.MiraCart?.refreshCart(0);
    }
    if (Shopify?.shop === "undiesforever.myshopify.com") {
      globalThis.publish("cart-update", {});
    }
    if (typeof window.SLIDECART_UPDATE === "function") {
      window.SLIDECART_UPDATE();
    }
    if (typeof window.ajaxCart?.load === "function") {
      window.ajaxCart.load();
    }
    if (typeof window.reloadCart === "function") {
      window.reloadCart();
    }
  } catch (e) {
    console.error("Failed to re-render cart: ", e);
  }
}
